// extracted by mini-css-extract-plugin
export var paquetesGrid = "Paquetes-module--paquetes-grid--h4nw6";